import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { useMediaQuery } from 'academy-common-lib/utils/Styling';
// @ts-expect-error Could not find a declaration file for module
import { useLocationWithoutParams } from '../../../hooks/searchParamHooks';
import RouterDropdownFilter, { RouterFilterTags, ClearFiltersLink, StyledTagsContainer } from '../../../containers/TracksPage/RouterDropdownFilter';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { css } from 'styled-components';
import { isSearchFilter, isSortFilter, useGuardFilterParams, useSearchFilter, useSortFilter } from '..';
import { useMemo } from 'react';
import { RouterSearchInput } from '../../../features/filters/components/RouterSearchInput';
import { RouterSelectSingle } from '../../../features/filters/components/RouterSelectSingle';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterContainer = styled(UISection).withConfig({
  displayName: "TopFilters__FilterContainer",
  componentId: "vobqir-0"
})(["position:relative;margin-left:-12px;margin-top:-20px !important;margin-bottom:4px !important;"]);
const StyledSearchInput = styled(RouterSearchInput).withConfig({
  displayName: "TopFilters__StyledSearchInput",
  componentId: "vobqir-1"
})(["", ""], ({
  hasFilters
}) => hasFilters ? css(["margin-bottom:10px;"]) : css(["margin-top:12px;margin-bottom:20px;"]));
const RouterSelectSingleStyled = styled(RouterSelectSingle).withConfig({
  displayName: "TopFilters__RouterSelectSingleStyled",
  componentId: "vobqir-2"
})(["&&{overflow:visible;}margin-right:12px;"]);
export const TopFilters = ({
  enabledFilters,
  showClearButton = true,
  showLabel = true,
  showTags = true
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const [hasFilters] = useLocationWithoutParams(enabledFilters);
  const searchFilter = useSearchFilter(enabledFilters);
  const sortFilterType = useSortFilter(enabledFilters);
  useGuardFilterParams();
  const dropdownFilters = useMemo(() => {
    return enabledFilters.map(filter => {
      if (isSearchFilter(filter) || isSortFilter(filter)) return null;
      switch (filter) {
        case FILTER_TYPES.ASSIGNED_BY:
          return /*#__PURE__*/_jsx(UIInlineLabel, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.topFilters.${filter}.filterTitle`
            }),
            children: /*#__PURE__*/_jsx(RouterSelectSingle, {
              filterType: filter
            })
          });
        case FILTER_TYPES.CREATED_BY:
        case FILTER_TYPES.LANGUAGE:
        case FILTER_TYPES.PROGRESS_STATUS:
          return /*#__PURE__*/_jsx(RouterSelectSingle, {
            filterType: filter,
            retainSelection: false,
            valueRenderer: () => /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.topFilters.${filter}.filterTitle`
            })
          });
        default:
          return /*#__PURE__*/_jsx(RouterDropdownFilter, {
            filterType: filter
          }, `top-filter-${filter}`);
      }
    }).filter(Boolean);
  }, [enabledFilters]);
  const sortFilter = useMemo(() => {
    return sortFilterType ? /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${sortFilterType}.filterTitle`
        }), ":"]
      }),
      children: /*#__PURE__*/_jsx(RouterSelectSingleStyled, {
        filterType: sortFilterType,
        menuWidth: 270
      })
    }) : null;
  }, [sortFilterType]);
  const showSearchOnLeft = !dropdownFilters.length && !sortFilter && searchFilter;
  const showSortFilterOnLeft = !!sortFilter && !dropdownFilters.length;
  return isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FilterContainer, {
      children: /*#__PURE__*/_jsxs(StyledTagsContainer, {
        children: [enabledFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
          filterType: filter
        }, filter)), showClearButton && /*#__PURE__*/_jsx(ClearFiltersLink, {
          filtersToClear: enabledFilters
        })]
      })
    }), searchFilter && /*#__PURE__*/_jsx(StyledSearchInput, {
      className: "search-input",
      filterType: searchFilter,
      hasFilters: hasFilters && showClearButton
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFilterBar, {
      className: "top-filters-bar m-top-0 m-bottom-4",
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [sortFilterType && !showSortFilterOnLeft && sortFilter, !showSearchOnLeft && searchFilter && /*#__PURE__*/_jsx(RouterSearchInput, {
          filterType: searchFilter
        })]
      }),
      startSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [showLabel && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), dropdownFilters.length ? dropdownFilters : showSearchOnLeft && /*#__PURE__*/_jsx(RouterSearchInput, {
          filterType: searchFilter
        }), showSortFilterOnLeft && sortFilter]
      })
    }), /*#__PURE__*/_jsxs(StyledTagsContainer, {
      children: [showTags && enabledFilters.map(filter => !isSearchFilter(filter) && /*#__PURE__*/_jsx(RouterFilterTags, {
        filterType: filter
      }, filter)), showClearButton && /*#__PURE__*/_jsx(ClearFiltersLink, {
        filtersToClear: enabledFilters
      })]
    })]
  });
};
export default TopFilters;